module.exports = __webpack_public_path__ + "assets/img/tx101c_1.a072ee16.jpg";